import React, { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import NotVerified from "../../assets/images/icons/not-verified.svg";
import UserVerified from "../../assets/images/icons/user-verified.svg";
import Authentihash from "../../assets/images/icons/verified-authentihash.svg";
import BytePattern from "../../assets/images/icons/verified-byte-pattern.svg";
import Certificate from "../../assets/images/icons/verified-certificate.svg";
import CloudSource from "../../assets/images/icons/verified-cloud-source.svg";
import Manifest from "../../assets/images/icons/verified-manifest.svg";
import Sha256 from "../../assets/images/icons/verified-sha256.svg";
import Similarity from "../../assets/images/icons/verified-similarity.svg";
import Verified from "../../assets/images/icons/verified.svg";
import { Tooltip } from "../index";
const ICONS = {
    "Not verified": NotVerified,
    "User override": UserVerified,
    "SHA-256": Sha256,
    Authentihash,
    Certificate,
    "Cloud source": CloudSource,
    "Byte Pattern": BytePattern,
    Similarity,
    Manifest,
};
const Icon = forwardRef(({ verified, ...props }, ref) => {
    var _a;
    const Glyph = verified === true ? Verified : ((_a = ICONS[verified]) !== null && _a !== void 0 ? _a : Verified);
    return (React.createElement(SvgIcon, { ref: ref, ...props },
        React.createElement(Glyph, null)));
});
Icon.displayName = "Icon";
const VerifiedBy = ({ verified, ...props }) => {
    if (verified === false) {
        return React.createElement(Icon, { verified: "Not verified", ...props });
    }
    else if (verified === true) {
        return React.createElement(Icon, { verified: true, ...props });
    }
    else {
        const title = verified === "Not verified" ? "Not verified" : `Verified by ${verified}`;
        return (React.createElement(Tooltip, { trigger: "graphic", title: title },
            React.createElement(Icon, { verified: verified, ...props })));
    }
};
export default VerifiedBy;
//# sourceMappingURL=VerifiedBy.js.map